export default [
  {
    path: '/ai-prompt',
    component: () => import('./views/Index'),
    name: 'ai-prompt',
    redirect: { name: 'ai-prompt-list' },
    children: [
      {
        path: '',
        name: 'ai-prompt-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'social-plus',
        },
      },
    ],
  },
]
